var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1Socket3P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 38a4.5 4.5 0 114.5 4.5 4.491 4.491 0 01-4.5-4.5zM31.5 23.09a6.5 6.5 0 116.5 6.5 6.51 6.51 0 01-6.5-6.5zm4 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zM38 49.41a4.5 4.5 0 104.5 4.5 4.49 4.49 0 00-4.5-4.5zM7 38a31 31 0 1162.001 0A31 31 0 017 38zm3.76 0A27.24 27.24 0 1038 10.76 27.27 27.27 0 0010.76 38zm13.49 4.5a4.5 4.5 0 10-4.5-4.5 4.49 4.49 0 004.5 4.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket_3P.a3683304.svg";
export { SvgA1Socket3P as ReactComponent };